export default "/images/vendor/flag-icon-css/flags/4x3/xk.svg?06ff301ff0dc8369a202b32a3568f6b9";